global.$ = require("jquery");
require([
    "../src/video.js",
    "../src/content_interesting_links.js",
    "../src/comments.js",
    "../src/remove_empty_objectarticle.js"
], function() {
});
